export async function decryptHtml(encryptedHtml, ivBase64, keyBase64, authTagBase64) {
  try {
    // Decode base64 values
    const encryptedData = Uint8Array.from(atob(encryptedHtml), char => char.charCodeAt(0));
    const iv = Uint8Array.from(atob(ivBase64), char => char.charCodeAt(0));
    const keyRaw = Uint8Array.from(atob(keyBase64), char => char.charCodeAt(0));
    const authTag = Uint8Array.from(atob(authTagBase64), char => char.charCodeAt(0));

    // Combine encrypted data and authTag (GCM expects them together)
    const cipherTextWithTag = new Uint8Array(encryptedData.length + authTag.length);
    cipherTextWithTag.set(encryptedData);
    cipherTextWithTag.set(authTag, encryptedData.length);

    // Import the key
    const cryptoKey = await window.crypto.subtle.importKey(
      'raw',
      keyRaw,
      { name: 'AES-GCM' },
      false,
      ['decrypt'],
    );

    // Decrypt
    const decryptedBuffer = await window.crypto.subtle.decrypt(
      {
        name: 'AES-GCM',
        iv: iv,
        tagLength: 128, // 16 bytes
      },
      cryptoKey,
      cipherTextWithTag,
    );

    // Convert ArrayBuffer to string
    return new TextDecoder().decode(decryptedBuffer);
  } catch (error) {
    console.error('Decryption error:', error);
    return '<div>Failed to decrypt content</div>';
  }
}
